import {
  Modal,
  ModalBody,
  ModalBodyProps,
  ModalCloseButton,
  ModalContent,
  ModalContentProps,
  ModalFooter,
  ModalFooterProps,
  ModalOverlay,
  ModalProps,
} from "@chakra-ui/react";
import { PropsWithChildren } from "react";

export interface FullModalProps {
  modal: Omit<ModalProps, "children">;
  bodySx?: ModalBodyProps;
  contentSx?: ModalContentProps;
  footer?: ModalFooterProps;
  noOverlay?: boolean;
}
export function FullModal(props: PropsWithChildren<FullModalProps>) {
  return (
    <Modal {...props.modal}>
      {!props?.noOverlay && <ModalOverlay h="100vh" />}
      <ModalContent
        position={{
          base: "fixed",
          md: "relative",
        }}
        bottom={{ base: "0px" }}
        mb="0"
        p="4"
        borderRadius={{
          base: "1.75rem 1.75rem 0px 0px",
          md: "md",
        }}
        {...props.contentSx}
      >
        <ModalCloseButton outline="none" _focus={{ outline: "none" }} />
        <ModalBody {...props?.bodySx}>{props.children}</ModalBody>
        {props?.footer && <ModalFooter {...props?.footer} />}
      </ModalContent>
    </Modal>
  );
}
